import React from 'react'
import extendedLogo from '../assets/hacklab-extended-white.png'
import {SOCIAL_LINKS} from '../socialLinks'

export default function Footer() {
    return (
        <footer className='py-10 w-full border-t bg-dark border-dark-800'>
            <div className='grid grid-cols-1 gap-6 items-center px-4 mx-auto max-w-6xl md:grid-cols-3'>
                <img src={extendedLogo} alt='theHackLab' className='mx-auto w-auto h-10 opacity-80 md:mx-0' />

                <div className='flex gap-4 justify-center items-center'>
                    {SOCIAL_LINKS.map(social => (
                        <a
                            key={social.name}
                            href={social.href}
                            target='_blank'
                            rel='noopener noreferrer'
                            aria-label={social.name}
                            className='flex justify-center items-center w-10 h-10 rounded-full border transition-colors border-dark-700 text-dark-300 hover:text-light hover:border-accent'
                        >
                            {social.icon}
                        </a>
                    ))}
                </div>

                <p className='text-sm text-center text-dark-400 md:text-right'>&copy; {new Date().getFullYear()} theHackLab Bocconi Students</p>
            </div>
        </footer>
    )
}
